import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import World from "@frog/source/models/World.js"

export default {
    "slug": "y2",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "text": "Free the prisoners",
        "conditions": [
            {
                // Chapter opening
                "type": "turn:0:start",
                "events": [
                    // "MUSIC: Music:Combat:Epic",
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawnspot"}),
                    "PRINCESS: hello world",
                    `PRINCESS: # expression: happy
                        The hour is at hand comrades,
                        to cast off the chains of the captive
                        and walk boldly into **freedom**!`,
                    "STRANGER (FRIEND): 'Bout damn time, eh?",
                    "HERO: ATTACKS 14x21 14x20 14x19",
                    `HIMMEL:
                        This carceral injustice shall not stand`,
                ]
            },
            ...PlotScripts.EncounterVictories({"encounterKeys": [1, 2, 3, 4], "nextURL": "/games/war/chapters/y3"}),
            PlotScripts.ChapterFailure(),
        ]
    },
}
